// Get all airlines
export const GET_AIRLINES_DETAILS_REQUEST = "GET_AIRLINES_DETAILS_REQUEST";
export const GET_AIRLINES_DETAILS_SUCCESS = "GET_AIRLINES_DETAILS_SUCCESS";
export const GET_AIRLINES_DETAILS_FAIL = "GET_AIRLINES_DETAILS_FAIL";
export const GET_AIRLINES_DETAILS_RESET = "GET_AIRLINES_DETAILS_RESET";

// create HX rules
export const CREATE_HX_RULES_REQUEST = "CREATE_HX_RULES_REQUEST";
export const CREATE_HX_RULES_SUCCESS = "CREATE_HX_RULES_SUCCESS";
export const CREATE_HX_RULES_FAIL = "CREATE_HX_RULES_FAIL";
export const CREATE_HX_RULES_RESET = "CREATE_HX_RULES_RESET";
// create Agency Booking Report rules
export const CREATE_AGENCY_BOOKING_REPORT_RULES_REQUEST =
  "CREATE_AGENCY_BOOKING_REPORT_RULES_REQUEST";
export const CREATE_AGENCY_BOOKING_REPORT_RULES_SUCCESS =
  "CREATE_AGENCY_BOOKING_REPORT_RULES_SUCCESS";
export const CREATE_AGENCY_BOOKING_REPORT_RULES_FAIL =
  "CREATE_AGENCY_BOOKING_REPORT_RULES_FAIL";
export const CREATE_AGENCY_BOOKING_REPORT_RULES_RESET =
  "CREATE_AGENCY_BOOKING_REPORT_RULES_RESET";
// create SC rules
export const CREATE_SC_RULES_REQUEST = "CREATE_SC_RULES_REQUEST";
export const CREATE_SC_RULES_SUCCESS = "CREATE_SC_RULES_SUCCESS";
export const CREATE_SC_RULES_FAIL = "CREATE_SC_RULES_FAIL";
export const CREATE_SC_RULES_RESET = "CREATE_SC_RULES_RESET";

// create Customer
export const CREATE_CUSTOMER_REQUEST = "CREATE_CUSTOMER_REQUEST";
export const CREATE_CUSTOMER_SUCCESS = "CREATE_CUSTOMER_SUCCESS";
export const CREATE_CUSTOMER_FAIL = "CREATE_CUSTOMER_FAIL";
export const CREATE_CUSTOMER_RESET = "CREATE_CUSTOMER_RESET";

// Send OTP
export const SEND_OTP_REQUECT = "SEND_OTP_REQUECT";
export const SEND_OTP_SUCCESS = "SEND_OTP_SUCCESS";
export const SEND_OTP_FAIL = "SEND_OTP_FAIL";
export const SEND_OTP_RESET = "SEND_OTP_RESET";

// Login
export const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAIL = "USER_LOGIN_FAIL";
export const USER_LOGIN_RESET = "USER_LOGIN_RESET";

// Logout
export const USER_LOGOUT = "USER_LOGOUT";

// Admin Details
export const ADMIN_DETAILS_REQUEST = "ADMIN_DETAILS_REQUEST";
export const ADMIN_DETAILS_SUCCESS = "ADMIN_DETAILS_SUCCESS";
export const ADMIN_DETAILS_FAIL = "ADMIN_DETAILS_FAIL";
export const ADMIN_DETAILS_RESET = "ADMIN_DETAILS_RESET";

// Get all HX Rules
export const GET_AL_HX_RULES_REQUEST = "GET_AL_HX_RULES_REQUEST";
export const GET_ALL_HX_RULES_SUCCESS = "GET_ALL_HX_RULES_SUCCESS";
export const GET_ALL_HX_RULES_FAIL = "GET_ALL_HX_RULES_FAIL";
export const GET_ALL_HX_RULES_RESET = "GET_ALL_HX_RULES_RESET";
// Get all Agency Booking Report Rules
export const GET_AL_AGENCY_BOOKING_REPORT_RULES_REQUEST =
  "GET_AL_AGENCY_BOOKING_REPORT_RULES_REQUEST";
export const GET_ALL_AGENCY_BOOKING_REPORT_RULES_SUCCESS =
  "GET_ALL_AGENCY_BOOKING_REPORT_RULES_SUCCESS";
export const GET_ALL_AGENCY_BOOKING_REPORT_RULES_FAIL =
  "GET_ALL_AGENCY_BOOKING_REPORT_RULES_FAIL";
export const GET_ALL_AGENCY_BOOKING_REPORT_RULES_RESET =
  "GET_ALL_AGENCY_BOOKING_REPORT_RULES_RESET";
//Get all SC Rules
export const GET_AL_SC_RULES_REQUEST = "GET_AL_SC_RULES_REQUEST";
export const GET_ALL_SC_RULES_SUCCESS = "GET_ALL_SC_RULES_SUCCESS";
export const GET_ALL_SC_RULES_FAIL = "GET_ALL_SC_RULES_FAIL";
export const GET_ALL_SC_RULES_RESET = "GET_ALL_SC_RULES_RESET";
//Get All Logs
export const GET_SERVER_LOGS_REQUEST = "GET_SERVER_LOGS_REQUEST";
export const GET_SERVER_LOGS_SUCCESS = "GET_SERVER_LOGS_SUCCESS";
export const GET_SERVER_LOGS_FAIL = "GET_SERVER_LOGS_FAIL";
export const GET_SERVER_LOGS_RESET = "GET_SERVER_LOGS_RESET";
// Get all Customers
export const GET_ALL_CUSTOMERS_REQUEST = "GET_ALL_CUSTOMERS_REQUEST";
export const GET_ALL_CUSTOMERS_SUCCESS = "GET_ALL_CUSTOMERS_SUCCESS";
export const GET_ALL_CUSTOMERS_FAIL = "GET_ALL_CUSTOMERS_FAIL";
export const GET_ALL_CUSTOMERS_RESET = "GET_ALL_CUSTOMERS_RESET";

// Get all active Customers
export const GET_ALL_ACTIVE_CUSTOMERS_REQUEST =
  "GET_ALL_ACTIVE_CUSTOMERS_REQUEST";
export const GET_ALL_ACTIVE_CUSTOMERS_SUCCESS =
  "GET_ALL_ACTIVE_CUSTOMERS_SUCCESS";
export const GET_ALL_ACTIVE_CUSTOMERS_FAIL = "GET_ALL_ACTIVE_CUSTOMERS_FAIL";
export const GET_ALL_ACTIVE_CUSTOMERS_RESET = "GET_ALL_ACTIVE_CUSTOMERS_RESET";

// Get all active and ticket report enabled Customers
export const GET_ALL_ACTIVE_REPORT_ENABLED_CUSTOMERS_REQUEST =
  "GET_ALL_ACTIVE_REPORT_ENABLED_CUSTOMERS_REQUEST";
export const GET_ALL_ACTIVE_REPORT_ENABLED_CUSTOMERS_SUCCESS =
  "GET_ALL_ACTIVE_REPORT_ENABLED_CUSTOMERS_SUCCESS";
export const GET_ALL_ACTIVE_REPORT_ENABLED_CUSTOMERS_FAIL =
  "GET_ALL_ACTIVE_REPORT_ENABLED_CUSTOMERS_FAIL";
export const GET_ALL_ACTIVE_REPORT_ENABLED_CUSTOMERS_RESET =
  "GET_ALL_ACTIVE_REPORT_ENABLED_CUSTOMERS_RESET";

// Get hx rule by id
export const GET_HX_RULE_REQUEST = "GET_HX_RULE_REQUEST";
export const GET_HX_RULE_SUCCESS = "GET_HX_RULE_SUCCESS";
export const GET_HX_RULE_FAIL = "GET_HX_RULE_FAIL";
export const GET_HX_RULE_RESET = "GET_HX_RULE_RESET";
// Get Agency Booking Report rule by id
export const GET_AGENCY_BOOKING_REPORT_RULE_REQUEST =
  "GET_AGENCY_BOOKING_REPORT_RULE_REQUEST";
export const GET_AGENCY_BOOKING_REPORT_RULE_SUCCESS =
  "GET_AGENCY_BOOKING_REPORT_RULE_SUCCESS";
export const GET_AGENCY_BOOKING_REPORT_RULE_FAIL =
  "GET_AGENCY_BOOKING_REPORT_RULE_FAIL";
export const GET_AGENCY_BOOKING_REPORT_RULE_RESET =
  "GET_AGENCY_BOOKING_REPORT_RULE_RESET";
// Get sc rule by id
export const GET_SC_RULE_REQUEST = "GET_SC_RULE_REQUEST";
export const GET_SC_RULE_SUCCESS = "GET_SC_RULE_SUCCESS";
export const GET_SC_RULE_FAIL = "GET_SC_RULE_FAIL";
export const GET_SC_RULE_RESET = "GET_SC_RULE_RESET";

// Get customer by id
export const GET_CUSTOMER_REQUEST = "GET_CUSTOMER_REQUEST";
export const GET_CUSTOMER_SUCCESS = "GET_CUSTOMER_SUCCESS";
export const GET_CUSTOMER_FAIL = "GET_CUSTOMER_FAIL";
export const GET_CUSTOMER_RESET = "GET_CUSTOMER_RESET";

// Get customer static data by customer id
export const GET_CUSTOMER_STATIC_DATA_REQUEST =
  "GET_CUSTOMER_STATIC_DATA_REQUEST";
export const GET_CUSTOMER_STATIC_DATA_SUCCESS =
  "GET_CUSTOMER_STATIC_DATA_SUCCESS";
export const GET_CUSTOMER_STATIC_DATA_FAIL = "GET_CUSTOMER_STATIC_DATA_FAIL";
export const GET_CUSTOMER_STATIC_DATA_RESET = "GET_CUSTOMER_STATIC_DATA_RESET";

// Update HX rule
export const UPDATE_HX_RULE_REQUEST = "UPDATE_HX_RULE_REQUEST";
export const UPDATE_HX_RULE_SUCCESS = "UPDATE_HX_RULE_SUCCESS";
export const UPDATE_HX_RULE_FAIL = "UPDATE_HX_RULE_FAIL";
export const UPDATE_HX_RULE_RESET = "UPDATE_HX_RULE_RESET";
// Update Agency Booking Report rule
export const UPDATE_AGENCY_BOOKING_REPORT_RULE_REQUEST =
  "UPDATE_AGENCY_BOOKING_REPORT_RULE_REQUEST";
export const UPDATE_AGENCY_BOOKING_REPORT_RULE_SUCCESS =
  "UPDATE_AGENCY_BOOKING_REPORT_RULE_SUCCESS";
export const UPDATE_AGENCY_BOOKING_REPORT_RULE_FAIL =
  "UPDATE_AGENCY_BOOKING_REPORT_RULE_FAIL";
export const UPDATE_AGENCY_BOOKING_REPORT_RULE_RESET =
  "UPDATE_AGENCY_BOOKING_REPORT_RULE_RESET";
// Update SC rule
export const UPDATE_SC_RULE_REQUEST = "UPDATE_SC_RULE_REQUEST";
export const UPDATE_SC_RULE_SUCCESS = "UPDATE_SC_RULE_SUCCESS";
export const UPDATE_SC_RULE_FAIL = "UPDATE_SC_RULE_FAIL";
export const UPDATE_SC_RULE_RESET = "UPDATE_SC_RULE_RESET";

// Update Customer
export const UPDATE_CUSTOMER_REQUEST = "UPDATE_CUSTOMER_REQUEST";
export const UPDATE_CUSTOMER_SUCCESS = "UPDATE_CUSTOMER_SUCCESS";
export const UPDATE_CUSTOMER_FAIL = "UPDATE_CUSTOMER_FAIL";
export const UPDATE_CUSTOMER_RESET = "UPDATE_CUSTOMER_RESET";

// Delete HX Rule
export const DELETE_HX_RULE_REQUEST = "DELETE_HX_RULE_REQUEST";
export const DELETE_HX_RULE_SUCCESS = "DELETE_HX_RULE_SUCCESS";
export const DELETE_HX_RULE_FAIL = "DELETE_HX_RULE_FAIL";
export const DELETE_HX_RULE_RESET = "DELETE_HX_RULE_RESET";
// Delete Agency Booking Report Rule
export const DELETE_AGENCY_BOOKING_REPORT_RULE_REQUEST =
  "DELETE_AGENCY_BOOKING_REPORT_RULE_REQUEST";
export const DELETE_AGENCY_BOOKING_REPORT_RULE_SUCCESS =
  "DELETE_AGENCY_BOOKING_REPORT_RULE_SUCCESS";
export const DELETE_AGENCY_BOOKING_REPORT_RULE_FAIL =
  "DELETE_AGENCY_BOOKING_REPORT_RULE_FAIL";
export const DELETE_AGENCY_BOOKING_REPORT_RULE_RESET =
  "DELETE_AGENCY_BOOKING_REPORT_RULE_RESET";
// Delete SC Rule
export const DELETE_SC_RULE_REQUEST = "DELETE_SC_RULE_REQUEST";
export const DELETE_SC_RULE_SUCCESS = "DELETE_SC_RULE_SUCCESS";
export const DELETE_SC_RULE_FAIL = "DELETE_SC_RULE_FAIL";
export const DELETE_SC_RULE_RESET = "DELETE_SC_RULE_RESET";

// Delete Customer
export const DELETE_CUSTOMER_REQUEST = "DELETE_CUSTOMER_REQUEST";
export const DELETE_CUSTOMER_SUCCESS = "DELETE_CUSTOMER_SUCCESS";
export const DELETE_CUSTOMER_FAIL = "DELETE_CUSTOMER_FAIL";
export const DELETE_CUSTOMER_RESET = "DELETE_CUSTOMER_RESET";

// Get all countries
export const GET_ALL_COUNTRY_REQUEST = "GET_ALL_COUNTRY_REQUEST";
export const GET_ALL_COUNTRY_SUCCESS = "GET_ALL_COUNTRY_SUCCESS";
export const GET_ALL_COUNTRY_FAIL = "GET_ALL_COUNTRY_FAIL";
export const GET_ALL_COUNTRY_RESET = "GET_ALL_COUNTRY_RESET";

// Get user by id
export const GET_USER_REQUEST = "GET_USER_REQUEST";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const GET_USER_FAIL = "GET_USER_FAIL";
export const GET_USER_RESET = "GET_USER_RESET";

// Get logged in user
export const GET_LOGGED_IN_USER_REQUEST = "GET_LOGGED_IN_USER_REQUEST";
export const GET_LOGGED_IN_USER_SUCCESS = "GET_LOGGED_IN_USER_SUCCESS";
export const GET_LOGGED_IN_USER_FAIL = "GET_LOGGED_IN_USER_FAIL";
export const GET_LOGGED_IN_USER_RESET = "GET_LOGGED_IN_USER_RESET";

// Get all users
export const GET_ALL_USERS_REQUEST = "GET_ALL_USERS_REQUEST";
export const GET_ALL_USERS_SUCCESS = "GET_ALL_USERS_SUCCESS";
export const GET_ALL_USERS_FAIL = "GET_ALL_USERS_FAIL";
export const GET_ALL_USERS_RESET = "GET_ALL_USERS_RESET";

// create User
export const CREATE_USER_REQUEST = "CREATE_USER_REQUEST";
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const CREATE_USER_FAIL = "CREATE_USER_FAIL";
export const CREATE_USER_RESET = "CREATE_USER_RESET";

// Delete user
export const DELETE_USER_REQUEST = "DELETE_USER_REQUEST";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_FAIL = "DELETE_USER_FAIL";
export const DELETE_USER_RESET = "DELETE_USER_RESET";

// Update user
export const UPDATE_USER_REQUEST = "UPDATE_USER_REQUEST";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAIL = "UPDATE_USER_FAIL";
export const UPDATE_USER_RESET = "UPDATE_USER_RESET";

// Reset Password
export const RESET_PASSWORD_REQUEST = "RESET_PASSWORD_REQUEST";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAIL = "RESET_PASSWORD_FAIL";
export const RESET_PASSWORD_RESET = "RESET_PASSWORD_RESET";

// Change Password
export const CHANGE_PASSWORD_REQUEST = "CHANGE_PASSWORD_REQUEST";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAIL = "CHANGE_PASSWORD_FAIL";
export const CHANGE_PASSWORD_RESET = "CHANGE_PASSWORD_RESET";

// Itinerary Data itinearary
export const GET_MANAGE_BOOKING_DATA_REQUEST =
  "GET_MANAGE_BOOKING_DATA_REQUEST";
export const GET_MANAGE_BOOKING_DATA_SUCCESS =
  "GET_MANAGE_BOOKING_DATA_SUCCESS";
export const GET_MANAGE_BOOKING_DATA_FAIL = "GET_MANAGE_BOOKING_DATA_FAIL";
export const GET_MANAGE_BOOKING_DATA_RESET = "GET_MANAGE_BOOKING_DATA_RESET";

// Print itinerary
export const PRINT_ITINERARY_DATA_REQUEST = "PRINT_ITINERARY_DATA_REQUEST";
export const PRINT_ITINERARY_DATA_SUCCESS = "PRINT_ITINERARY_DATA_SUCCESS";
export const PRINT_ITINERARY_DATA_FAIL = "PRINT_ITINERARY_DATA_FAIL";
export const PRINT_ITINERARY_DATA_RESET = "PRINT_ITINERARY_DATA_RESET";

// Email itinerary
export const EMAIL_ITINERARY_DATA_REQUEST = "EMAIL_ITINERARY_DATA_REQUEST";
export const EMAIL_ITINERARY_DATA_SUCCESS = "EMAIL_ITINERARY_DATA_SUCCESS";
export const EMAIL_ITINERARY_DATA_FAIL = "EMAIL_ITINERARY_DATA_FAIL";
export const EMAIL_ITINERARY_DATA_RESET = "EMAIL_ITINERARY_DATA_RESET";

// Products
export const GET_PRODUCTS_REQUEST = "GET_PRODUCTS_REQUEST";
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS";
export const GET_PRODUCTS_FAIL = "GET_PRODUCTS_FAIL";
export const GET_PRODUCTS_RESET = "GET_PRODUCTS_RESET";

// User permission
export const GET_USER_PERMISSION_REQUEST = "GET_USER_PERMISSION_REQUEST";
export const GET_USER_PERMISSION_SUCCESS = "GET_USER_PERMISSION_SUCCESS";
export const GET_USER_PERMISSION_FAIL = "GET_USER_PERMISSION_FAIL";
export const GET_USER_PERMISSION_RESET = "GET_USER_PERMISSION_RESET";

// Check PCC
export const CHECK_PCC_REQUEST = "CHECK_PCC_REQUEST";
export const CHECK_PCC_SUCCESS = "CHECK_PCC_SUCCESS";
export const CHECK_PCC_FAIL = "CHECK_PCC_FAIL";
export const CHECK_PCC_RESET = "CHECK_PCC_RESET";

// Get Ticket Report
export const GET_TICKET_REPORT_REQUEST = "GET_TICKET_REPORT_REQUEST";
export const GET_TICKET_REPORT_SUCCESS = "GET_TICKET_REPORT_SUCCESS";
export const GET_TICKET_REPORT_FAIL = "GET_TICKET_REPORT_FAIL";
export const GET_TICKET_REPORT_RESET = "GET_TICKET_REPORT_RESET";

// Get TP Batch Report
export const GET_TP_BATCH_REPORT_REQUEST = "GET_TP_BATCH_REPORT_REQUEST";
export const GET_TP_BATCH_REPORT_SUCCESS = "GET_TP_BATCH_REPORT_SUCCESS";
export const GET_TP_BATCH_REPORT_FAIL = "GET_TP_BATCH_REPORT_FAIL";
export const GET_TP_BATCH_REPORT_RESET = "GET_TP_BATCH_REPORT_RESET";

// Email Multi PCC Ticket Report
export const EMAIL_MULTI_PCC_TICKET_REPORT_REQUEST =
  "EMAIL_MULTI_PCC_TICKET_REPORT_REQUEST";
export const EMAIL_MULTI_PCC_TICKET_REPORT_SUCCESS =
  "EMAIL_MULTI_PCC_TICKET_REPORT_SUCCESS";
export const EMAIL_MULTI_PCC_TICKET_REPORT_FAIL =
  "EMAIL_MULTI_PCC_TICKET_REPORT_FAIL";
export const EMAIL_MULTI_PCC_TICKET_REPORT_RESET =
  "EMAIL_MULTI_PCC_TICKET_REPORT_RESET";

// Get all Currencies
export const GET_CURRENCY_REQUEST = "GET_CURRENCY_REQUEST";
export const GET_CURRENCY_SUCCESS = "GET_CURRENCY_SUCCESS";
export const GET_CURRENCY_FAIL = "GET_CURRENCY_FAIL";
export const GET_CURRENCY_RESET = "GET_CURRENCY_RESET";

// Download Excel file
export const DOWNLOAD_EXCEL_REQUEST = "DOWNLOAD_EXCEL_REQUEST";
export const DOWNLOAD_EXCEL_SUCCESS = "DOWNLOAD_EXCEL_SUCCESS";
export const DOWNLOAD_EXCEL_FAIL = "DOWNLOAD_EXCEL_FAIL";
export const DOWNLOAD_EXCEL_RESET = "DOWNLOAD_EXCEL_RESET";

//Download Invoice file
export const DOWNLOAD_INVOICE_REQUEST = "DOWNLOAD_INVOICE_REQUEST";
export const DOWNLOAD_INVOICE_SUCCESS = "DOWNLOAD_INVOICE_SUCCESS";
export const DOWNLOAD_INVOICE_FAIL = "DOWNLOAD_INVOICE_FAIL";
export const DOWNLOAD_INVOICE_RESET = "DOWNLOAD_INVOICE_RESET";

// Download CSV file
export const DOWNLOAD_CSV_REQUEST = "DOWNLOAD_CSV_REQUEST";
export const DOWNLOAD_CSV_SUCCESS = "DOWNLOAD_CSV_SUCCESS";
export const DOWNLOAD_CSV_FAIL = "DOWNLOAD_CSV_FAIL";
export const DOWNLOAD_CSV_RESET = "DOWNLOAD_CSV_RESET";

// create Customer login
export const CREATE_CUSTOMER_LOGIN_REQUEST = "CREATE_CUSTOMER_LOGIN_REQUEST";
export const CREATE_CUSTOMER_LOGIN_SUCCESS = "CREATE_CUSTOMER_LOGIN_SUCCESS";
export const CREATE_CUSTOMER_LOGIN_FAIL = "CREATE_CUSTOMER_LOGIN_FAIL";
export const CREATE_CUSTOMER_LOGIN_RESET = "CREATE_CUSTOMER_LOGIN_RESET";

// Get all Customers
export const GET_ALL_CUSTOMERS_LOGINS_REQUEST =
  "GET_ALL_CUSTOMERS_LOGINS_REQUEST";
export const GET_ALL_CUSTOMERS_LOGINS_SUCCESS =
  "GET_ALL_CUSTOMERS_LOGINS_SUCCESS";
export const GET_ALL_CUSTOMERS_LOGINS_FAIL = "GET_ALL_CUSTOMERS_LOGINS_FAIL";
export const GET_ALL_CUSTOMERS_LOGINS_RESET = "GET_ALL_CUSTOMERS_LOGINS_RESET";

// Update customer status (is active)
export const UPDATE_CUSTOMER_LOGINS_REQUEST = "UPDATE_CUSTOMER_LOGINS_REQUEST";
export const UPDATE_CUSTOMER_LOGINS_SUCCESS = "UPDATE_CUSTOMER_LOGINS_SUCCESS";
export const UPDATE_CUSTOMER_LOGINS_FAIL = "UPDATE_CUSTOMER_LOGINS_FAIL";
export const UPDATE_CUSTOMER_LOGINS_RESET = "UPDATE_CUSTOMER_LOGINS_RESET";

// Get all parent customers
export const GET_ALL_PARENT_CUSTOMERS_REQUEST =
  "GET_ALL_PARENT_CUSTOMERS_REQUEST";
export const GET_ALL_PARENT_CUSTOMERS_SUCCESS =
  "GET_ALL_PARENT_CUSTOMERS_SUCCESS";
export const GET_ALL_PARENT_CUSTOMERS_FAIL = "GET_ALL_PARENT_CUSTOMERS_FAIL";
export const GET_ALL_PARENT_CUSTOMERS_RESET = "GET_ALL_PARENT_CUSTOMERS_RESET";

// Remove customer logo
export const REMOVE_CUSTOMER_LOGO_REQUEST = "REMOVE_CUSTOMER_LOGO_REQUEST";
export const REMOVE_CUSTOMER_LOGO_SUCCESS = "REMOVE_CUSTOMER_LOGO_SUCCESS";
export const REMOVE_CUSTOMER_LOGO_FAIL = "REMOVE_CUSTOMER_LOGO_FAIL";
export const REMOVE_CUSTOMER_LOGO_RESET = "REMOVE_CUSTOMER_LOGO_RESET";

// Get Queue List
export const GET_QUEUELIST_REQUEST = "GET_QUEUELIST_REQUEST";
export const GET_QUEUELIST_SUCCESS = "GET_QUEUELIST_SUCCESS";
export const GET_QUEUELIST_FAIL = "GET_QUEUELIST_FAIL";
export const GET_QUEUELIST_RESET = "GET_QUEUELIST_RESET";
